import { render, staticRenderFns } from "./NavGroupsLinkEntry.vue?vue&type=template&id=3d265036&scoped=true"
import script from "./NavGroupsLinkEntry.vue?vue&type=script&lang=js"
export * from "./NavGroupsLinkEntry.vue?vue&type=script&lang=js"
import style0 from "./NavGroupsLinkEntry.vue?vue&type=style&index=0&id=3d265036&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d265036",
  null
  
)

export default component.exports